/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * API Авторизация
 * API для демонстрации
 * OpenAPI spec version: v1
 */
import {
  HttpClient
} from '@angular/common/http';

import {
  Injectable
} from '@angular/core';

import type {
  CreateUserCommand,
  CreateUserCommandResponse,
  GetApiUsersParams,
  GetFilteredUsersQueryResponseQueryPaginationResult,
  GetUserQueryResponse,
  PostApiUsersExportToExcelParams,
  PostApiUsersIdResetPasswordParams,
  UpdateUserBodyCommand,
  UpdateUserCommandResponse
} from '../../../interfaces/user-auth';

import { userAuthFetcher } from '../../../fetchers/user-auth.fetcher';




// eslint-disable-next-line
    type ThirdParameter<T extends (...args: any) => any> = T extends (
  config: any,
  httpClient: any,
  args: infer P,
) => any
  ? P
  : never;

@Injectable({ providedIn: 'root' })
export class UsersService {
  constructor(
    private http: HttpClient,
  ) {}/**
 * @summary Получить список пользователей с фильтрацией.
 */
 getApiUsers<TData = GetFilteredUsersQueryResponseQueryPaginationResult>(
    params?: GetApiUsersParams,
 options?: ThirdParameter<typeof userAuthFetcher>) {
      return userAuthFetcher<TData>(
      {url: `/api/users`, method: 'GET',
        params
    },
      this.http,
      options);
    }
  /**
 * @summary Создать нового пользователя.
 */
 postApiUsers<TData = CreateUserCommandResponse>(
    createUserCommand: CreateUserCommand,
 options?: ThirdParameter<typeof userAuthFetcher>) {
      return userAuthFetcher<TData>(
      {url: `/api/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserCommand
    },
      this.http,
      options);
    }
  /**
 * @summary Получить данные пользователя по его ID.
 */
 getApiUsersInternalId<TData = GetUserQueryResponse>(
    id: string,
 options?: ThirdParameter<typeof userAuthFetcher>) {
      return userAuthFetcher<TData>(
      {url: `/api/users/internal/${id}`, method: 'GET'
    },
      this.http,
      options);
    }
  /**
 * @summary Получить данные пользователя по его ID.
 */
 getApiUsersId<TData = GetUserQueryResponse>(
    id: string,
 options?: ThirdParameter<typeof userAuthFetcher>) {
      return userAuthFetcher<TData>(
      {url: `/api/users/${id}`, method: 'GET'
    },
      this.http,
      options);
    }
  /**
 * @summary Обновить данные пользователя.
 */
 putApiUsersId<TData = UpdateUserCommandResponse>(
    id: string,
    updateUserBodyCommand: UpdateUserBodyCommand,
 options?: ThirdParameter<typeof userAuthFetcher>) {
      return userAuthFetcher<TData>(
      {url: `/api/users/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserBodyCommand
    },
      this.http,
      options);
    }
  /**
 * @summary Удалить пользователя по ID.
 */
 deleteApiUsersId<TData = void>(
    id: string,
 options?: ThirdParameter<typeof userAuthFetcher>) {
      return userAuthFetcher<TData>(
      {url: `/api/users/${id}`, method: 'DELETE'
    },
      this.http,
      options);
    }
  /**
 * @summary Получить данные текущего пользователя.
 */
 getApiUsersMe<TData = GetUserQueryResponse>(
    
 options?: ThirdParameter<typeof userAuthFetcher>) {
      return userAuthFetcher<TData>(
      {url: `/api/users/me`, method: 'GET'
    },
      this.http,
      options);
    }
  /**
 * @summary Экспортировать список пользователей в формате Excel.
 */
 postApiUsersExportToExcel<TData = void>(
    params?: PostApiUsersExportToExcelParams,
 options?: ThirdParameter<typeof userAuthFetcher>) {
      return userAuthFetcher<TData>(
      {url: `/api/users/exportToExcel`, method: 'POST',
        params
    },
      this.http,
      options);
    }
  /**
 * @summary Сбросить пароль пользователя.
 */
 postApiUsersIdResetPassword<TData = void>(
    id: string,
    params?: PostApiUsersIdResetPasswordParams,
 options?: ThirdParameter<typeof userAuthFetcher>) {
      return userAuthFetcher<TData>(
      {url: `/api/users/${id}/resetPassword`, method: 'POST',
        params
    },
      this.http,
      options);
    }
  };

export type GetApiUsersClientResult = NonNullable<GetFilteredUsersQueryResponseQueryPaginationResult>
export type PostApiUsersClientResult = NonNullable<CreateUserCommandResponse>
export type GetApiUsersInternalIdClientResult = NonNullable<GetUserQueryResponse>
export type GetApiUsersIdClientResult = NonNullable<GetUserQueryResponse>
export type PutApiUsersIdClientResult = NonNullable<UpdateUserCommandResponse>
export type DeleteApiUsersIdClientResult = NonNullable<void>
export type GetApiUsersMeClientResult = NonNullable<GetUserQueryResponse>
export type PostApiUsersExportToExcelClientResult = NonNullable<void>
export type PostApiUsersIdResetPasswordClientResult = NonNullable<void>
